import Link from "next/link";
import {LISTING_TERMS} from "./listing-terms";

/**
 * The terms of use shown on the listing search and listing pages (browse-wrap, rule 6(d)(ii)):
 * one line that is always visible and links to the full terms, then the four required texts
 * folded under "Read the terms of use" (closed until the visitor opens it).
 */
export function TermsNotice() {
    return (
        <section aria-labelledby="listing-terms-heading" className="rounded-lg border bg-card px-4 py-3 text-sm text-card-foreground">
            <p id="listing-terms-heading">
                By viewing listings on this site you agree to the{" "}
                <Link href="/terms" className="underline underline-offset-2 hover:no-underline">Terms of use</Link>.
            </p>
            <details className="mt-2">
                <summary className="cursor-pointer">Read the terms of use</summary>
                <div className="mt-2 space-y-2">
                    <p>{LISTING_TERMS.trademarks}</p>
                    <p>{LISTING_TERMS.accuracy}</p>
                    <p>{LISTING_TERMS.operator}</p>
                    <p>{LISTING_TERMS.copyright}</p>
                </div>
            </details>
        </section>
    );
}
